import Icon from '../components/Icon.vue'

Icon.register({
  'file-contract': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM64 72C64 67.6 67.6 64 72 64H152C156.4 64 160 67.6 160 72V88C160 92.4 156.4 96 152 96H72C67.6 96 64 92.4 64 88V72zM64 136C64 131.6 67.6 128 72 128H152C156.4 128 160 131.6 160 136V152C160 156.4 156.4 160 152 160H72C67.6 160 64 156.4 64 152V136zM256.8 384H304C312.8 384 320 391.2 320 400S312.8 416 304 416H256.8C240.4 416 225.5 406.9 218.2 392.1 215.2 386.2 210.1 385.6 208 385.6S200.8 386.2 198 391.8L190.3 407.1A16-16 0 0 0 176 416C175.6 416 175.3 416 174.9 415.9 168.4 415.5 162.9 411.2 160.8 405.1L144 354.6 133.4 386.5C127.5 404.1 111 416 92.4 416H80C71.2 416 64 408.8 64 400S71.2 384 80 384H92.4C97.2 384 101.5 380.9 103 376.3L121.2 321.7C124.5 311.9 133.7 305.3 144 305.3S163.5 311.9 166.8 321.7L180.7 363.3C200.4 347.1 234.7 353.6 246.7 377.5 248.7 381.6 252.6 384 256.8 384zM377 105L279.1 7C274.6 2.5 268.5 0 262.1 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-contract.js
// module id = CAOO
// module chunks = 144